import React from 'react';
import { Show, TabbedShowLayout, Tab, TabbedShowLayoutTabs } from 'react-admin';
import { gql } from '@apollo/client';
import useCheckAccess from 'hooks/useCheckAccess';
import PermanentPlacementShowActions from './ShowActions';
import PermanentPlacementApplicationsTab from './tabs/PermanentPlacementApplicationsTab';
import JobDetailsShowTab from './tabs/JobDetailsTab';
import LocationsTab from './tabs/LocationsTab';

const PermanentPlacementsShow = () => {
  const checkAccess = useCheckAccess();

  return (
    <Show actions={<PermanentPlacementShowActions />} data-testid="assignments-show">
      <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" />}>
        <Tab label="Job details">
          <JobDetailsShowTab />
        </Tab>
        {checkAccess('view', 'PermanentPlacementRequest') && (
          <Tab label="Applicants" path="requests">
            <PermanentPlacementApplicationsTab
              canManage={checkAccess('create', 'PermanentPlacementRequest')}
            />
          </Tab>
        )}
        {checkAccess('view', 'Location') && (
          <Tab label="Locations" path="locations">
            <LocationsTab />
          </Tab>
        )}
      </TabbedShowLayout>
    </Show>
  );
};

PermanentPlacementsShow.query = gql`
  query GET_ONE($id: Int!) {
    permanentPlacement(id: $id) {
      id
      professional_id
      positions {
        id
        display_name
      }
      surgery_types {
        id
        display_name
      }
      specialties {
        id
        label
      }
      starts_date
      starts_time
      ends_time
      jobs_detail
      status
      suspicious
      created_at
      updated_at
      number_of_openings
      available_professional_count
      offer
      locations {
        id
        covid_requirement
        timezone_lookup
        market {
          id
          display_name
          state {
            id
            covid_requirement
          }
        }
        state {
          id
          name
          covid_requirement
        }
      }
      assignment_locations {
        primary_location
        location {
          id
          sales_associate {
            id
            account {
              name
            }
          }
        }
      }
      primary_location {
        id
        timezone_lookup
        covid_requirement
        market {
          id
          state {
            id
            covid_requirement
          }
        }
        company {
          id
          health_system {
            id
            label
          }
          msp {
            id
            label
          }
          vms_type {
            id
            label
          }
        }
      }
      company_id
      company {
        id
      }
      permanent_min_hourly_rate_cents
      permanent_max_hourly_rate_cents
      surgery_types {
        id
      }
      patient_population
      number_of_shifts_per_week
      schedule_type
      permanent_openings
      permanent_summary
      permanent_qualifications
      permanent_benefits
    }
  }
`;

export default PermanentPlacementsShow;
